import React from 'react';
import Youtube from 'react-youtube';

import './css/styles.css';

class CardVideo extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            id_card: '',
        }
    }

    componentWillMount(){
        fetch('/api/uip/youtube/card', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => { this.setState({ id_card:  response[0].id_card})})
            .catch(response => console.log(response))
    }

    render(){
        
        const opts = {
            playerVars: {
                autoplay: 0
            }
        };

        return(
            <div className="container_video_inicio">
                <div className="card-image-video">
                    <div className="video-container custom-shadow-video">
                        <Youtube videoId={this.state.id_card} 
                                 opts={opts}
                                 onReady={this._onReady} />
                    </div>
                </div>
                <div className="card-content-video">
                    <p className={`custom-fontText`}>{this.props.texto}</p>
                </div>
            </div>
        );
    };

    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    };

}

export default CardVideo;